import {Store,Module,ActionContext} from 'vuex'
import {ListModule, ListState,ListMutations, ListStateItem, ListModuleItem} from '@/store/shared'
import {$http} from '@/lib'
import {PageResult} from '@/store/shared/entity';

import ContainerShipmentStatistics from './entity'
import Tree from "@/store/shared/entity/tree";

interface ContainerShipmentStatisticsState extends ListStateItem<ContainerShipmentStatistics>{
    editContainerShipmentStatistics:ContainerShipmentStatistics,
    totalLCL:number;
}

class ContainerShipmentStatisticsModule extends ListModuleItem<ContainerShipmentStatisticsState,any,ContainerShipmentStatistics>{

    constructor() {
        super();
        Object.assign(this.state, this.overrideState);
        Object.assign(this.mutations, this.overrideMutations);
    }

    overrideState={
        editContainerShipmentStatistics:new ContainerShipmentStatistics(),
        totalLCL:0,
    }
    actions={
        async getAll(context:ActionContext<ContainerShipmentStatisticsState,any>,payload:any){
            context.state.table.loading=true;
            let reponse=await $http.get('services/app/DeclareCustoms/GetContainerShipmentStatistics',{params:payload.data});
            context.state.table.loading=false;
            let page=reponse.data.result as PageResult<ContainerShipmentStatistics>;
            context.state.table.totalCount=page.totalCount;
            context.state.table.list=page.items;
            if(page.totalLCL>0){
                context.state.totalLCL=page.totalLCL;
            }
            else{
                context.state.totalLCL=0;
            }
            
        },
    };
    overrideMutations={
        edit(state:ContainerShipmentStatisticsState,containershipmentstatistics:ContainerShipmentStatistics){
            state.editContainerShipmentStatistics=containershipmentstatistics;
        }
    }
}
const containerShipmentStatisticsModule=new ContainerShipmentStatisticsModule();
export default containerShipmentStatisticsModule;